export function QHpassSignin(events) {
    QHPass.utils.defineError('1675', '阅读并同意“360游戏服务及许可协议”和“360游戏隐私政策”');
    QHPass.signIn(events.wrapper, function(userInfo) {
        events.signinSuccCallback(userInfo)
    });
}

